import { createClient } from 'postchain-client';

import { store } from '../../../store/store';
import { eChromiaActionTypes } from '../../../store/chromia/chromiaTypes';
import { backendForBestChrUrl, chromiaBlockchainRID, directoryNodeUrlPool, useBackendForBestChrUrl } from '../../../settings';
import { iTypedGtxClient } from '../../../interfaces/chrInterfaces';
import { eAppActionTypes } from '../../../store/app/appTypes';

let pendingBestChrNodePromise: Promise<string[] | null> | null = null;

export const getBestChrNodeUrls = async (): Promise<string[] | null> => {
    // 1. Если URL уже есть в сторе – используем его
    const { chrNodeUrl } = store.getState().app;
    if (chrNodeUrl) return chrNodeUrl;

    // 2. Если запрос уже выполняется – присоединяемся к нему
    if (pendingBestChrNodePromise) return pendingBestChrNodePromise;

    // 3. Создаём новый промис и сохраняем его
    pendingBestChrNodePromise = (async () => {
        try {
            const response = await fetch(`${backendForBestChrUrl}`);
            console.log("response:", response);
            if (response.status === 204) {
                return null;
            }

            const nodes = await response.json();
            if (!nodes || nodes.length === 0){
                return null;
            }
            /* const node1 = nodes[0];
            //console.log("text:", node1);
            if (node1 && node1.length>=1){
                //console.log("Best Chromia Node URL:", node1);
                store.dispatch({
                    type: eAppActionTypes.SET_CHR_NODE_URL,
                    payload: node1,
                });
                //console.log("text:", node1)
                return node1;
            } else {
                console.log("URL not found in response");
                return null;
            } */
			store.dispatch({
				type: eAppActionTypes.SET_CHR_NODE_URL,
				payload: nodes,
			});
			return nodes
        } catch (error) {
            console.log("Error:", error);
            return null;
        } finally {
            // 4. После завершения (успех/ошибка) очищаем промис,
            //    чтобы при следующем вызове можно было выполнить новый запрос
            pendingBestChrNodePromise = null;
        }
    })();

    return pendingBestChrNodePromise;
};

export const getGtxClient = async (): Promise<iTypedGtxClient> => {
	const { gtxClient: chrClient } = store.getState().chromia;
	if (chrClient) return chrClient;

	/* const response = await fetch(`${chromia_bc.node_api_url}brid/iid_0`);
	if (!response.ok) throw new Error();
	const rid = await response.text(); */

	const nodeUrls = useBackendForBestChrUrl? await getBestChrNodeUrls() : null;

    const _directoryNodeUrlPool = nodeUrls? nodeUrls : directoryNodeUrlPool;

    // console.log("chromiaBlockchainUrl:", chromiaBlockchainUrl);
    /* if (!nodeUrl) {
        _directoryNodeUrlPool = directoryNodeUrlPool;
    } else {
        if (nodeUrl.includes('w3coins.io') || nodeUrl.includes('sunube.net') || nodeUrl.includes('chromia.01node') || nodeUrl.includes('nocturnallabs')){
            nodeUrl = nodeUrl+':7740';
        } else if (nodeUrl.includes('caliber.build')){
            nodeUrl = nodeUrl+':443';
        }
        _directoryNodeUrlPool = [`https://${nodeUrl}`];
    } */
    console.log("directoryNodeUrlPool:", _directoryNodeUrlPool);

	const newChrClient = await createClient({
		nodeUrlPool: _directoryNodeUrlPool,
		// directoryNodeUrlPool,
		blockchainRid: chromiaBlockchainRID
	}) as iTypedGtxClient;

	store.dispatch({
		type: eChromiaActionTypes.SET_GTX_CLIENT,
		payload: newChrClient
	})

	return newChrClient;
}